import { supabase } from '@/lib/supabase';
import type { Branch } from '../stores/branch-store';
import type { SupabaseClient } from '@/lib/supabase';

// Check if Supabase is properly configured
let supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.SUPABASE_URL || '';
if (supabaseUrl.includes('=')) {
  supabaseUrl = supabaseUrl.split('=')[1] || '';
}
const isSupabaseConfigured = supabaseUrl.startsWith('https://') && supabaseUrl.includes('.supabase.co');

/**
 * Create a new branch
 */
export async function createBranch(
  data: Pick<Branch, 'name' | 'location' | 'phone' | 'lat' | 'lng' | 'is_main' | 'operating_hours'> & { id?: string }
): Promise<Branch> {
  const branchId = data.id || `branch-${Date.now()}`;

  if (!isSupabaseConfigured || !supabase) {
    // Return mock data for demo mode
    return {
      id: branchId,
      name: data.name,
      location: data.location,
      phone: data.phone,
      lat: data.lat,
      lng: data.lng,
      is_main: data.is_main || false,
      operating_hours: data.operating_hours,
    };
  }

  const supabaseClient = supabase as SupabaseClient;
  
  const insertData: Record<string, unknown> = {
    id: branchId,
    name: data.name,
    location: data.location || null,
    phone: data.phone || null,
    lat: data.lat || null,
    lng: data.lng || null,
    is_main: data.is_main || false,
    operating_hours: data.operating_hours || null,
  };

  const result = await supabaseClient
    .from('branches')
    .insert(insertData as never)
    .select()
    .single();

  if (result.error) {
    console.error('Error creating branch:', result.error);
    throw new Error(result.error.message);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const branch: any = result.data;
  return {
    id: branch.id,
    name: branch.name,
    location: branch.location || '',
    phone: branch.phone || '',
    lat: branch.lat,
    lng: branch.lng,
    is_main: branch.is_main || false,
    operating_hours: branch.operating_hours,
  };
}
